<template>

  <div id="employee_details" :class="{ 'voi-verified': employment_verified }" @click="removeVoiRequestId">

  <md-subheader>Employment Details</md-subheader>

  <div class="md-layout input-layout">
    <!-- Search Address -->
    <search-text-input
      class="md-layout-item md-size-100"
      label="Search Business"
      icon="search"
      :searcher="performSearch"
      :prefixLabel="prefixLabel"
      @select="selectEmployment"
    >
      <template v-slot="{ item }">
        {{ item.name }}
      </template>
    </search-text-input>
  </div>

  <div>
    <div class="md-layout input-layout">
    <!-- Type -->
    <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-10"
      label="Type" v-model="employment.type"
      :prefixLabel="prefixLabel"
      :options="employment_types"
      :required="isEmploymentRequired"
      force
    />

    <!-- Title -->
    <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
      label="Title" v-model="employment.title" :prefixLabel="prefixLabel">
    </validated-text-input>

    <!-- Industry -->
    <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-20"
      label="Industry" v-model="employment.industry"
      :prefixLabel="prefixLabel"
      :options="options.employment_industry"
      force
    />

    <!-- Occupation -->
    <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-15"
      label="Occupation" v-model="employment.occupation"
      :prefixLabel="prefixLabel"
      :options="options.employment_occupation"
      force
    />
    </div>
  </div>

  <!-- Probation -->
  <!-- <md-switch class="md-layout-item md-small-size-100 md-size-10"
  v-model="employment.probation">Probation</md-switch> -->
  <div>
    <div class="md-layout input-layout">
      <div class="md-layout-item md-size-10">
        <md-checkbox class="md-layout-item md-small-size-100 md-size-10"
        v-if="!previous"
        v-model="probation">Probation</md-checkbox>
      </div>

      <!-- Duration Years -->
      <validated-input
        type="DURATION_YEARS"
        class="md-layout-item md-small-size-100 md-size-10"
        label="Years"
        :prefixLabel="prefixLabel"
        :required="is_employment_type_and_employer_name_present || isYearRequired"
        v-model="employment.duration.years"
      />

      <!-- Duration Months -->
      <validated-input
        type="DURATION_MONTHS"
        class="md-layout-item md-small-size-100 md-size-10"
        label="Months"
        :prefixLabel="prefixLabel"
        :required="is_employment_type_and_employer_name_present || isMonthRequired"
        v-model="employment.duration.months"
      />

      <!-- Employer -->
      <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
        label="Employer" v-model="employment.employer_details.name" :prefixLabel="prefixLabel">
      </validated-text-input>

      <!-- ABN -->
      <validated-number-input class="md-layout-item md-small-size-100 md-size-15"
        label="ABN"
        v-model="employment.employer_details.abn"
        :prefixLabel="prefixLabel"
        integer
        maxLength="11"
        minLength="6"
        errormsg="Please enter a valid ABN between 6 and 11 characters in length"
      >
      </validated-number-input>

      <!-- Contact Name-->
      <validated-text-input class="md-layout-item md-small-size-100 md-size-15"
        label="Contact Name" v-model="employment.employer_details.contact_name" :prefixLabel="prefixLabel">
      </validated-text-input>

      <!-- Contact Phone-->
      <validated-text-input
        class="md-layout-item md-small-size-100 md-size-15"
        label="Contact Phone"
        v-model="employment.employer_details.contact_number"
        :prefixLabel="prefixLabel"
        prefix="+"
        :minLength=7
        :maxLength=15
        errormsg="Please enter a valid phone number, format can contain 7 to 15 digits"
      />
    </div>

    <div>
      <div class="md-layout input-layout md-alignment-center-left">

        <!-- ABN registration date -->
        <validated-input
          type="DATE"
          v-if="is_self_employed"
          class="md-layout-item md-small-size-100 md-size-20 date-input"
          label="ABN Registration"
          :prefixLabel="prefixLabel"
          prefixYear="past"
          v-model="employment.employer_details.abn_registration_date"
        />

        <!-- GST registration date -->
        <validated-input
          type="DATE"
          v-if="is_self_employed"
          class="md-layout-item md-small-size-100 md-size-20 date-input"
          label="GST Registration"
          :prefixLabel="prefixLabel"
          prefixYear="past"
          v-model="employment.employer_details.gst_registration_date"
        />

        <!-- Income Amount -->
        <validated-input
          v-if="!previous"
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-20"
          label="Net Income (After tax)"
          :required="is_employment_type_and_employer_name_present"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="employment.income.amount"
          :suffix="toMonthlyAmount(employment.income.amount, employment.income.frequency, true) + '/m'"
          :max=14
          :minValue="is_employment_type_and_employer_name_present ? 1 : 0"
        />
        <!-- Income Frequency -->
        <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-10"
          v-if="!previous"
          label="Frequency" v-model="employment.income.frequency"
          :prefixLabel="prefixLabel"
          :options="options.payment_frequency_options"
          force
        />

        <!-- Equifax VOI -->
        <div
          class="md-layout-item md-small-size-100 md-size-20"
          v-if="!employment_verified">
          <loading-icon-text-button
            class="md-primary md-sm"
            @click="equifax_voi_lookup"
            icon="search"
            :loading="loading_voi_lookup">
              Verification Of Income
          </loading-icon-text-button>
        </div>

        <div
          class="md-layout-item md-small-size-100 md-size-25"
          v-if="employment_verified">
          <loading-icon-text-button
            class="voi-badge"
            icon="check">
            <p>Verification Of Income: Certified</p>
          </loading-icon-text-button>
        </div>

        <VoiDialog
          :show="show_modal"
          :isUpdating="isUpdating"
          :voi_data="voi_data"
          @decline="show_modal = false"
          @proceed="changeStatus('proceed')"
        />

        <md-dialog-alert
        :md-active.sync="error_alert.show"
        :md-content="error_alert.message"
        md-confirm-text="Close"
        />

      </div>
    </div>
  </div>

  <md-subheader>Employment Address</md-subheader>
  <md-checkbox class="md-layout-item md-small-size-100 md-size-12"
      v-if="is_self_employed"
      v-model="employment.address.same_as_residential">Same as Home Address</md-checkbox>
  <edit-applicant-address :value="employment.address" :prefixLabel="prefixLabel"/>

  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import ValidatedInputs from '@/components/ValidatedInput';
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import EditApplicantAddress from './EditApplicantAddress.vue';
import LoadingIconTextButton from '../LoadingIconTextButton';
import {newAddress} from "../../schema";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import ConfirmDialog from "../Dialogs/ConfirmDialog";
import VoiDialog from '../Dialogs/VOI/VoiDialog.vue';
import VoiNotFoundDialog from '../Dialogs/VOI/VoiNotFoundDialog.vue';

export default {
  components: {
  ...ValidatedInputs,
  ListItemCard,
  EditApplicantAddress,
  LoadingIconTextButton,
  VoiDialog,
  VoiNotFoundDialog
},
  data() {
    return {
      voi_data: {},
      loading_voi_lookup: false,
      show_modal: false,
      isUpdating: false,
      isStatusFail: false,
      search: {
        query: '',
        status: 'unloaded',
        results: [],
        queryer: null,
        pause_detector: null,
      },
      error_alert:{
        show: false,
        message:''
      },
      errorMessage : '',
      reasonMessage : '',
      declinedNotificationContent: 'Do you wish to send a declined email notification to customer?',
      isMonthRequired: false,
      isYearRequired: false,
      isEmploymentRequired: false,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    applicant:{
      type: Object,
      required: false
    },
    previous: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
    disableOther: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
      application: 'application',
      user: "user"
    }),
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    employment: {
      get(){ return this.value; },
      set(employment){ this.$emit('input', employment); },
    },
    applicant_for_employment: {
      get() {
        return this.applicant;
      },
    },
    employment_verified: {
      get() {
        return this.employment.voi_request_id;
      }
    },
    probation: {
      get() {
      if (this.employment) {
        // only convert string 0/1
        if (this.employment.probation === '0') {
          return false;
        } else if (this.employment.probation === '1') {
          return true;
        }
          return this.employment.probation;
        }
        return false;
      },
      set(value) {
      this.employment.probation = value;
      }
    },
    employment_types () {
      if (this.disableOther) {
        // remove other from employment type
        return this.options.employment_type_options.filter(item => item !== 'Other' && item !== 'Unknown');
      }
      // not showing 'Unknown' in the dropdown
      return this.options.employment_type_options.filter(item => item !== 'Unknown');
    },
    is_self_employed(){
      return this.employment.type == 'Self Employed';
    },
    is_same_as_residential(){
      return this.employment.address.same_as_residential;
    },
    is_employment_type_and_employer_name_present(){
      return Boolean(this.employment.type && this.employment.employer_details.name);
    }
  },
  watch: {
    value: {
      handler(){
        this.$emit('change', this.value);
      },
      deep: true,
    },
    'employment.address.same_as_residential':{
      handler() {
      if (this.is_same_as_residential) {
        this.applicant_for_employment.addresses.current.address.same_as_residential = this.is_same_as_residential;
        this.employment.address = this.applicant_for_employment.addresses.current.address;
      } else{
        this.employment.address = newAddress();
      }
      },
    },
    'employment.employer_details.abn':{
      handler(newValue) {
        this.employment.employer_details.abn = newValue.replace(' ', '');
      },
    },
    'employment.employer_details.contact_number':{
      handler(newValue) {
        this.employment.employer_details.contact_number = newValue.replace(' ', '');
      },
    },
    "employment.duration.years"(newVal) {
      this.isYearRequired = newVal === null && this.employment.duration.months !== null;
      this.isMonthRequired = newVal !== null && this.employment.duration.months === null;
    },
    "employment.duration.months"(newVal) {
      this.isYearRequired = newVal !== null && this.employment.duration.years === null;
      this.isMonthRequired = newVal === null && this.employment.duration.years !== null;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    async performSearch(query){
      const queryType = utils.checkBussinessQueryType(query);
      let params = { [queryType] : query };
      if (this.value.address.post_code && queryType == 'name') {
        params.postcode = this.value.address.post_code;
      }

      let response = await axios.get(`/api/v1/sensis/business_by_${queryType}/search`, { params, maxRedirects:0 });
      return response.data;
    },
    selectEmployment(result){
      this.value.employer_details.name = result.name;
      this.value.employer_details.abn = result.ABN;
    },
    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },
    showVOINotFound(title, message, confirmText, cancelText = null) {
        return this.$modal.show(VoiNotFoundDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },
    async removeVoiRequestId () {
        if(this.employment_verified) {
            this.employment.voi_request_id = null
            let result = await this.$store.dispatch("save_application", this.application);
            const response = await this.$store.dispatch("add_audit_log", {
                application_id:  this.application.loan.id,
                message : `Remove voi verified employment ${this.employment.employer_details.contact_name} by ${this.user.first_name} ${this.user.last_name}`
            });
        }
    },
    async equifax_voi_lookup() {
      this.$store.commit('set_is_editing', this.isEditing);
      const res = await this.showNotification(
        "Confirm",
        "This will fetch a new copy of the applicant's VOI data and may incur an additional charge. Continue?",
        "Confirm",
        "Cancel"
      );
      if (!res) {
        this.isEditing = false;
        this.$store.commit('set_is_editing', this.isEditing);
        return res;
      }
      this.$modal.show(WaitingDialog, {
        title: 'Fetching VOI data...',
        message: 'Please wait whilst we are fetching the applicant\'s income data.',
      });
      try {
        this.loading_voi_lookup = true;
        let result = await this.$store.dispatch('request_voi_for_application',
        {
          application_data: this.application,
          applicant_id: this.applicant.id
        });
        this.voi_data = JSON.parse(result.data);
        this.show_modal = true;
        this.closeOpenModals();
      } catch (e) {
      // if the waiting dialog is open, close it
        this.closeOpenModals();
        this.show_modal = false;
        this.isUpdating = false;
        if (e && e.response) {
          let error = e.response.data
          if (error.includes("VOI data not found for specified applicant")) {
            this.showVOINotFound(`Fetching VOI data failed for: ${this.name(this.applicant.contact.name)}`, error, "Ok" );
          } else {
            this.showNotification(`Fetching VOI data failed for: ${this.name(this.applicant.contact.name)}`, error, "Ok" );
          }

          this.loading_voi_lookup = false;
        }
      }
      this.loading_voi_lookup = false;
      this.$store.commit("redirect_after_save", this.application);
    },
    async changeStatus(newStatus) {
      const res = await this.showNotification(
        "Confirm VOI Data Backfill",
        "This will overwrite the current employment details for the specified applicant. Continue?",
        "Confirm",
        "Cancel"
      );
      if (!res) {
        this.show_modal = false;
        return;
      }
      this.isUpdating = true;
      if (newStatus == 'decline') {
        this.setStatusAndReason('Lost', 'Declined', 'VOI Declined', 'Declined after VOI data fetch.');
        try {
          //refresh application data once status is changed
          await this.$store.dispatch('update_application_status', {
            application_id: this.application.loan.id,
            stage: this.application.loan.status.stage,
            status: this.application.loan.status.status,
            reason: this.application.loan.status.reason,
            comment: this.application.loan.status.comment,
          });
          //refresh workbasket once the status is changed
          this.$store.commit('set_work_basket', null);

          // If application declined, send notification to applicant.
          this.sendDeclinedNotification()

          this.show_modal = false;
          this.isUpdating = false;
        } catch (error) {
          console.log(error);
          this.closeOpenModals();
          this.isStatusFail = true;
          this.showNotification(`Updating application status failed`, error, "Ok" );
        }
      } else {
        try {
          await this.$store.dispatch('backfill_voi', {
            applicant_id: this.applicant.id
          });
          this.$emit('application-change');
          this.show_modal = false;
          this.isUpdating = false;
          this.isEditing = false;
          this.$store.commit('set_is_editing', this.isEditing);
          window.removeEventListener('beforeunload', this.preventNav);
        } catch(error) {
          this.showNotification(`Backfilling VOI data failed`, error, "Ok" );
          console.log(error);
          this.closeOpenModals();
          this.show_modal = false;
          this.isUpdating = false;
          this.loading_voi_lookup = false;
        }
      }
    },
    closeOpenModals() {
      if (this.$modal.submit){
        this.$modal.submit();
      }
    },
    setStatusAndReason(stage, status, reason, comment){
      this.application.loan.status.status = status;
      this.application.loan.status.stage = stage;
      this.application.loan.status.reason = reason;
      this.application.loan.status.comment = comment;
    },
    async sendDeclinedNotification () {
      const resp = await this.showNotification('', this.declinedNotificationContent, 'Yes', 'No')
      if (!resp) {
        return
      }

      await axios.post(`/api/v1/application/send-client-declined-notification`, {
        application_id: this.application.loan.id
      }).catch((error) => {
        console.error(error)
        this.showErrorDialog("Failed to send to notification", true, false);
      })
    },
  },
  filters: {
  // make all filters available as filters
  ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'employment_industry',
        'employment_occupation',
        'payment_frequency_options',
        'employment_type_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  mounted () {
    if (this.employment && this.disableOther && this.employment.type === "Other") {
      this.employment.type = "";
      // make the employment type field as required to force user to select new value
      this.isEmploymentRequired = true;
    }

    if (this.employment && this.employment.type === "Unknown") {
      this.employment.type = "";
    }
  },
};
</script>

<style scoped>

.voi-badge {
  background-color: #DAA520 !important;
  pointer-events: none;
}
.voi-verified {
  background-color: #ffe9ec;
}

</style>
